export const CAREER_PATHS = [{
  value: 'security-analyst',
  label: 'Security Analyst'
}, {
  value: 'pentester',
  label: 'Pentester'
}, {
  value: 'security-engineer',
  label: 'Security Engineer'
}];